"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PHONE_NUMBER_SUBTEXT = exports.CTA_TYPES = void 0;
var CTA_TYPES = {
  APPLY_NOW: 'APPLY_NOW',
  READ_REVIEW: 'READ_REVIEW',
  PREQUAL: 'PREQUAL'
};
exports.CTA_TYPES = CTA_TYPES;
var PHONE_NUMBER_SUBTEXT = 'or call ';
exports.PHONE_NUMBER_SUBTEXT = PHONE_NUMBER_SUBTEXT;